import i18n from '../../i18n'

export function getHelpButtonOptions() {
  return [
    {
      label: i18n.t('Header.FaqLinkOptionHelpCenterKey'),
      to: 'https://idwell.crunch.help/de/servicemeldungen',
      value: 'helpCenter',
    },
    {
      label: i18n.t('Header.FaqLinkOptionLiveChatKey'),
      to: ' https://idwell.crunch.help/de',
      value: 'liveChat',
    },
    {
      label: i18n.t('Header.FaqLinkOptionTutorialsKey'),
      to: 'https://www.youtube.com/playlist?list=PLrBu65APO8M2gSob5XFrvkDts1oE4WvSO',
      value: 'tutorials',
    },
    {
      label: i18n.t('Header.FaqLinkOptionAcademyKey'),
      to: 'https://www.idwell.com/at/academy/courses',
      value: 'academy',
    },
    {
      label: i18n.t('Header.FaqLinkOptionFeaturesAndUpdatesKey'),
      to: 'https://idwell.crunch.help/de/updates-tutorials',
      value: 'featuresAndUpdates',
    },
  ]
}
